﻿import { Component, Input, HostBinding } from '@angular/core';
import { ErrorService, ErrorButtonType } from './error.service';

function sleep(ms: number) {
    return new Promise(res => setTimeout(res, ms));
}

@Component({
    selector: 'error-modal',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css']
})
export class ErrorComponent {

    errorButtonText = {
        "Close": "Luk",
        "Reload": "Restart application",
    } as { [key in ErrorButtonType]: string }

    get errorButtonType() {
        return this.errorService.errorButtonType;
    }

    get errorMessage() {
        return this.errorService.message ? this.errorService.message : "An error occurred!";
    }

    constructor(private errorService: ErrorService) {
        errorService.shown
            .subscribe(shown => {
                this.show = shown;

                if (shown)
                    document.body.classList.add('error-state-active');
                else
                    document.body.classList.remove('error-state-active');
            });
    }


    @Input() show: boolean = false;

    onClick() {
        if (this.errorButtonType === "Reload")
            return this.reload();

        if (this.errorButtonType === "Close")
            return this.close();
    }
    
    reload() {
        window.location.reload();
    }

    async close() {
        if (this.errorService.onClose)
            this.errorService.onClose();

        document.body.classList.remove('error-state-active');
        // Return to the default behavior 
        
        await sleep(300);
        this.errorService.errorButtonType = "Reload";
    }
}